
import axios from "axios";
// import { actionStart, actionSuccess, actionFailed } from "../redux/ActionSlice";

export const getCountries = async () => {
    // dispatch(actionStart())
    try {
        const resp = axios.get('https://api.first.org/data/v1/countries');
        // dispatch(actionSuccess())
        return resp
    } catch (err) {
        // dispatch(actionFailed())
        return err
    }
}